export const SIGN_IN = 'SING_IN';
export const SIGN_UP = 'SING_UP';
export const SIGN_OUT = 'SING_OUT';
